__webpack_require__.p = "/brigitte-powers-coding-portfolio/";